module.exports = __webpack_public_path__ + "img/backendIcon.c445aa5a.png";